import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CreateNewPlan, ExercisePlan } from 'src/models/plan.model';
import { ItemReorderEventDetail } from '@ionic/core';

@Component({
    selector: 'app-create-plan',
    templateUrl: './create-plan.component.html',
    styleUrls: ['./create-plan.component.scss'],
    standalone: false
})
export class CreatePlanComponent implements OnInit {
  @Input() exercisesRefs: ExercisePlan[] = [];
  @Input() defaultSets = 3;
  @Input() planName: string = '';
  @Input() planDescription: string = '';
  @Input() loading: boolean = false;
  @Output() emitCreatedExercse = new EventEmitter<CreateNewPlan>();

  constructor() {}

  ngOnInit() {}

  emitPlan() {
    this.emitCreatedExercse.emit({
      planName: this.planName,
      planDescription: this.planDescription,
      defaultSets: this.defaultSets,
      exercisesRefs: this.exercisesRefs,
    });
  }

  addExercise(exerciseId: string) {
    const isExisting = this.exercisesRefs.some(
      (exercise) => exercise.id === exerciseId
    );

    if (!isExisting) {
      const newExercise: ExercisePlan = {
        id: exerciseId,
        sets: +this.defaultSets,
      };

      this.exercisesRefs.push(newExercise);
    }
  }

  removeExercise(exerciseId: string) {
    this.exercisesRefs = this.exercisesRefs.filter(
      (exercise) => exercise.id !== exerciseId
    );
  }

  addExercises(exerciseRef: string[]) {
    exerciseRef.forEach((exerciseId) => this.addExercise(exerciseId));
  }

  doReorder(event: CustomEvent<ItemReorderEventDetail>) {
    const fromIndex = event.detail.from;
    const toIndex = event.detail.to;

    const movedItem = this.exercisesRefs.splice(fromIndex, 1)[0];
    this.exercisesRefs.splice(toIndex, 0, movedItem);

    event.detail.complete();
  }
}
